<template>
  <md-table-cell>
    <md-field>
      <md-select v-model="filterValue" md-dense>
        <md-option value>-</md-option>
        <md-option value=true>Yes</md-option>
        <md-option value=false>No</md-option>
      </md-select>
    </md-field>
  </md-table-cell>
</template>

<script>
    import IndexTableFilter from "@/new/components/Index/IndexTableFilter";

    export default {
        name: "IndexTableFilterBool",
        mixins: [IndexTableFilter],
    }
</script>